import '../styles/menu.css'
import '../styles/default.css'
import '../styles/libs-index.css'
import '../styles/about.css'
import '../styles/main.css'
import '../styles/speakers.css'
import '../styles/program.css'
import 'owl.carousel/dist/assets/owl.carousel.css';

import 'fullpage.js'
import 'owl.carousel';
import './jquery.formstyler.min'
import './lazyload.min'
import './metrika'

$(function () {

  var fullpageDesktop = {
    menu: "#mainMenu",
    anchors:["home","about","who","speakers","program","afterparty","sponsors","partners","contacts"],
    css3:!0,
    scrollingSpeed:1e3,
    responsiveHeight:768,
    responsiveWidth:1068,
    paddingTop:"0",
    paddingBottom:"0",
    afterLoad:function(t,e){
      $(".asideBLock, .menuButton, .asideMenu").removeClass("active");
      var i=$(".asideMenu__item.hidden");
      if(e == 2) {
        i.show().prev().hide();
      }
    },
    onLeave:function(t,e,i){
      var screen=$(".asideMenu__item.hidden");
      if(e == 1 && i == 'down' || e == 2 && i == 'up') {
        screen.show().prev().hide();
      }
      if(e == 1 && i == 'up') {
        screen.hide().prev().show();
      }
      if(e != 1 && !(e == 2 && i == 'up')) {
        screen.hide().prev().show();
      }
    }
  }
  var windowSize = window.innerWidth;
  if(windowSize > 1068) {
    $("#fullpage").fullpage(fullpageDesktop);
  }
  var currentFullpageOptions = windowSize <= 1068 ? "mobile" : "desktop";
  $(window).on("resize", function () {
    window.innerWidth <= 1068 && "mobile" != currentFullpageOptions ? ($.fn.fullpage.destroy("all"), currentFullpageOptions = "mobile") : window.innerWidth > 1068 && "desktop" != currentFullpageOptions && ($("#fullpage").fullpage(fullpageDesktop), currentFullpageOptions = "desktop")
  })

  $(".asideMenu__link").on("click", function () {
    if (!($('html').hasClass('fp-enabled'))) {
      var $this = $(this),
        menu = $("#mainMenu"),
        sectionName = $this.data("menuanchor"),
        top = $(".section[data-anchor='" + sectionName + "']").offset().top - $(".asideTop").innerHeight();

      menu.find(".active").removeClass("active");
      $this.addClass("active");

      $("html, body").animate({
        scrollTop: top
      }, 0);
      $(".menuButton, .asideMenu, .asideBLock").removeClass("active");
    }
  });

  $("#menuGamburger").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active").next().toggleClass("active");
    $(".asideBLock").toggleClass("active");
  });

  // styler (decorating forms - select, checkbox, radio etc.)
  $(".cd-select").styler().closest(".langSelect").css("opacity", "1");

  $(window).on("load resize", function () {
    $(".cd-select").trigger("refresh");
    // меняем класс у бокового меню, если экран слишком низкий и меню полностью не вмещается
    var sidebar = $(".asideBLock");
    if (sidebar.outerHeight() < 750) {
      sidebar.addClass("asideBLock-low");
    } else {
      sidebar.removeClass("asideBLock-low");
    }
  });

  $('#cd-dropdown').on('change', function () {
    const pathArr = window.location.pathname.split('/')
    if (this.value == "2") {
      pathArr[pathArr.length - 2] = 'en'
    } else {
      pathArr[pathArr.length - 2] = 'ru'
    }
    window.location.pathname = pathArr.join('/')
  });

  // owl carousel
  if($(".afterparty__slider").length) {
    var owl = $(".afterparty__slider").owlCarousel({
      items: 1,
      nav: true,
      dots: false,
      loop: true,
      lazyLoad: true
    });
    var owlThumbs = $(".afterparty__thumbs").owlCarousel({
      items: 4,
      dots: false,
      lazyLoad: true
    });
    $(".afterparty__thumbsItem").on("click", function (e) {
      e.preventDefault();
      var $this = $(this),
        slideIndex = $this.data("index");

      owl.trigger("to.owl.carousel", [slideIndex, 300]);
    });
  }

  if ($(".lazyload").length) {
    lazyload();
  }
});